/* eslint-disable */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SiteAssignment = exports.ServiceStatus = exports.RenewalType = exports.ProviderName = exports.ProductTypeContext = exports.PremiumStatus = exports.PremiumPlanDataModelType = exports.PremiumAssetType = exports.PaymentStatus = exports.PaymentCollectionType = exports.MailboxVendorType = exports.DomainPrivacyStatus = exports.DomainManagementType = exports.DigitalGoodType = exports.CancellationPolicy = exports.BillingCycle = exports.AllowedAction = void 0;
var AllowedAction;
(function (AllowedAction) {
    AllowedAction["UNKNOWN"] = "UNKNOWN";
    AllowedAction["TRANSFER"] = "TRANSFER";
    AllowedAction["DISCONNECT"] = "DISCONNECT";
    AllowedAction["UPDATE_PAYMENT_METHOD"] = "UPDATE_PAYMENT_METHOD";
    AllowedAction["CONNECT_DISCONNECT_TO_SITE"] = "CONNECT_DISCONNECT_TO_SITE";
    AllowedAction["CHANGE_CYCLE"] = "CHANGE_CYCLE";
    AllowedAction["CHANGE_PRODUCT"] = "CHANGE_PRODUCT";
})(AllowedAction = exports.AllowedAction || (exports.AllowedAction = {}));
var BillingCycle;
(function (BillingCycle) {
    BillingCycle["ONE_TIME"] = "ONE_TIME";
    BillingCycle["DAILY"] = "DAILY";
    BillingCycle["WEEKLY"] = "WEEKLY";
    BillingCycle["MONTHLY"] = "MONTHLY";
    BillingCycle["QUARTERLY"] = "QUARTERLY";
    BillingCycle["SEMI_ANNUALLY"] = "SEMI_ANNUALLY";
    BillingCycle["YEARLY"] = "YEARLY";
    BillingCycle["TWO_YEARS"] = "TWO_YEARS";
    BillingCycle["THREE_YEARS"] = "THREE_YEARS";
    BillingCycle["FOUR_YEARS"] = "FOUR_YEARS";
    BillingCycle["FIVE_YEARS"] = "FIVE_YEARS";
})(BillingCycle = exports.BillingCycle || (exports.BillingCycle = {}));
var CancellationPolicy;
(function (CancellationPolicy) {
    CancellationPolicy["UNKNOWN"] = "UNKNOWN";
    CancellationPolicy["TRIAL_CANCELLATION"] = "TRIAL_CANCELLATION";
    CancellationPolicy["AUTO_RENEW_OFF"] = "AUTO_RENEW_OFF";
    CancellationPolicy["NOT_CANCELABLE"] = "NOT_CANCELABLE";
})(CancellationPolicy = exports.CancellationPolicy || (exports.CancellationPolicy = {}));
var DigitalGoodType;
(function (DigitalGoodType) {
    DigitalGoodType["UNKNOWN_DIGITAL_GOOD_TYPE"] = "UNKNOWN_DIGITAL_GOOD_TYPE";
    DigitalGoodType["IMAGE"] = "IMAGE";
    DigitalGoodType["VIDEO"] = "VIDEO";
    DigitalGoodType["LOGO"] = "LOGO";
})(DigitalGoodType = exports.DigitalGoodType || (exports.DigitalGoodType = {}));
var DomainManagementType;
(function (DomainManagementType) {
    DomainManagementType["DMT_UNKNOWN"] = "DMT_UNKNOWN";
    DomainManagementType["WIX_DOMAIN"] = "WIX_DOMAIN";
    DomainManagementType["EXTERNAL_POINTING_DOMAIN"] = "EXTERNAL_POINTING_DOMAIN";
    DomainManagementType["EXTERNAL_DNS_MANAGED"] = "EXTERNAL_DNS_MANAGED";
})(DomainManagementType = exports.DomainManagementType || (exports.DomainManagementType = {}));
var DomainPrivacyStatus;
(function (DomainPrivacyStatus) {
    DomainPrivacyStatus["DPS_UNKNOWN"] = "DPS_UNKNOWN";
    DomainPrivacyStatus["NO_PRIVACY_PURCHASED"] = "NO_PRIVACY_PURCHASED";
    DomainPrivacyStatus["PRIVACY_TURNED_ON"] = "PRIVACY_TURNED_ON";
    DomainPrivacyStatus["PRIVACY_TURNED_OFF"] = "PRIVACY_TURNED_OFF";
})(DomainPrivacyStatus = exports.DomainPrivacyStatus || (exports.DomainPrivacyStatus = {}));
var MailboxVendorType;
(function (MailboxVendorType) {
    MailboxVendorType["UNKNOWN_MAILBOX_TYPE"] = "UNKNOWN_MAILBOX_TYPE";
    MailboxVendorType["GOOGLE"] = "GOOGLE";
    MailboxVendorType["MSN"] = "MSN";
})(MailboxVendorType = exports.MailboxVendorType || (exports.MailboxVendorType = {}));
var PaymentCollectionType;
(function (PaymentCollectionType) {
    PaymentCollectionType["PMT_UNKNOWN"] = "PMT_UNKNOWN";
    PaymentCollectionType["SUBSCRIPTION"] = "SUBSCRIPTION";
    PaymentCollectionType["NON_PAYABLE"] = "NON_PAYABLE";
    PaymentCollectionType["ONE_TIME"] = "ONE_TIME";
})(PaymentCollectionType = exports.PaymentCollectionType || (exports.PaymentCollectionType = {}));
var PaymentStatus;
(function (PaymentStatus) {
    PaymentStatus["UNKNOWN_PAYMENT_STATUS"] = "UNKNOWN_PAYMENT_STATUS";
    PaymentStatus["PAID"] = "PAID";
    PaymentStatus["CHARGE_FAILURE"] = "CHARGE_FAILURE";
    PaymentStatus["REFUNDED"] = "REFUNDED";
    PaymentStatus["IN_PROGRESS"] = "IN_PROGRESS";
    PaymentStatus["NO_PAYMENT"] = "NO_PAYMENT";
    PaymentStatus["NOT_BILLABLE"] = "NOT_BILLABLE";
})(PaymentStatus = exports.PaymentStatus || (exports.PaymentStatus = {}));
var PremiumAssetType;
(function (PremiumAssetType) {
    PremiumAssetType["UNKNOWN_ASSET_TYPE"] = "UNKNOWN_ASSET_TYPE";
    PremiumAssetType["PLAN"] = "PLAN";
    PremiumAssetType["DOMAIN"] = "DOMAIN";
    PremiumAssetType["MAILBOX"] = "MAILBOX";
    PremiumAssetType["APP"] = "APP";
    PremiumAssetType["DIGITAL_GOOD"] = "DIGITAL_GOOD";
    PremiumAssetType["CATALOG_PRODUCT"] = "CATALOG_PRODUCT";
})(PremiumAssetType = exports.PremiumAssetType || (exports.PremiumAssetType = {}));
var PremiumPlanDataModelType;
(function (PremiumPlanDataModelType) {
    PremiumPlanDataModelType["NOT_APPLICABLE"] = "NOT_APPLICABLE";
    PremiumPlanDataModelType["DYNAMIC_OFFERING"] = "DYNAMIC_OFFERING";
    PremiumPlanDataModelType["LEGACY_PREMIUM_PLANS"] = "LEGACY_PREMIUM_PLANS";
})(PremiumPlanDataModelType = exports.PremiumPlanDataModelType || (exports.PremiumPlanDataModelType = {}));
var PremiumStatus;
(function (PremiumStatus) {
    PremiumStatus["UNKNOWN_PREMIUM_STATUS"] = "UNKNOWN_PREMIUM_STATUS";
    PremiumStatus["FREE"] = "FREE";
    PremiumStatus["PENDING"] = "PENDING";
    PremiumStatus["PREMIUM"] = "PREMIUM";
})(PremiumStatus = exports.PremiumStatus || (exports.PremiumStatus = {}));
var ProductTypeContext;
(function (ProductTypeContext) {
    ProductTypeContext["UNKNOWN"] = "UNKNOWN";
    ProductTypeContext["ACCOUNT"] = "ACCOUNT";
    ProductTypeContext["SITE"] = "SITE";
})(ProductTypeContext = exports.ProductTypeContext || (exports.ProductTypeContext = {}));
var ProviderName;
(function (ProviderName) {
    ProviderName["UNKNOWN"] = "UNKNOWN";
    ProviderName["SBS"] = "SBS";
    ProviderName["LICENSER"] = "LICENSER";
    ProviderName["BASS"] = "BASS";
    ProviderName["RESELLER"] = "RESELLER";
    ProviderName["RECURRING_INVOICES"] = "RECURRING_INVOICES";
})(ProviderName = exports.ProviderName || (exports.ProviderName = {}));
var RenewalType;
(function (RenewalType) {
    RenewalType["UNKNOWN"] = "UNKNOWN";
    RenewalType["AUTO_RENEW_ON"] = "AUTO_RENEW_ON";
    RenewalType["AUTO_RENEW_OFF"] = "AUTO_RENEW_OFF";
    RenewalType["MANUAL"] = "MANUAL";
})(RenewalType = exports.RenewalType || (exports.RenewalType = {}));
var ServiceStatus;
(function (ServiceStatus) {
    ServiceStatus["UNKNOWN_SERVICE_STATUS"] = "UNKNOWN_SERVICE_STATUS";
    ServiceStatus["ACTIVE"] = "ACTIVE";
    ServiceStatus["NOT_ACTIVE"] = "NOT_ACTIVE";
    ServiceStatus["TRANSFERRED"] = "TRANSFERRED";
    ServiceStatus["PENDING_SERVICE_STATUS"] = "PENDING_SERVICE_STATUS";
})(ServiceStatus = exports.ServiceStatus || (exports.ServiceStatus = {}));
var SiteAssignment;
(function (SiteAssignment) {
    SiteAssignment["UNKNOWN"] = "UNKNOWN";
    SiteAssignment["All"] = "All";
    SiteAssignment["ASSIGN_ONLY"] = "ASSIGN_ONLY";
    SiteAssignment["UN_ASSIGN_ONLY"] = "UN_ASSIGN_ONLY";
})(SiteAssignment = exports.SiteAssignment || (exports.SiteAssignment = {}));
//# sourceMappingURL=types.js.map